module.exports = __webpack_public_path__ + "img/priyanka.c755e673.webp";